// extracted by mini-css-extract-plugin
export default {"popular":"styles_popular__BYWsp"};